import { CleaningReportList } from '../../modules/cleaning/cleaning-report-list/components/CleaningReportList/CleaningReportList';

export const CleaningReportListPage = (): JSX.Element => <CleaningReportList />;
